export default __webpack_public_path__ + "static/media/centerImg.cb20ca03.png";